module.exports = __webpack_public_path__ + "static/media/cover-home-5.1af7e3ba.jpg";